export default (ex: unknown): string => {
  if ((ex as Error).message !== undefined) {
    return (ex as Error).message
  }
  return JSON.stringify(ex)
}
